export const IconWebfontHash = '9a5db7f1b60'

export type IconName =
  | 'addons'
  | 'adult'
  | 'ai-blink'
  | 'ai-refresh-solid'
  | 'ai-refresh'
  | 'ai-replied-text'
  | 'ai-search'
  | 'ai-solid'
  | 'ai'
  | 'airbnb-quality'
  | 'alert-circle'
  | 'alert-triangle'
  | 'alert-triangle2'
  | 'alert-triangle3'
  | 'align-bottom'
  | 'align-left'
  | 'align-right'
  | 'align-top'
  | 'angle-down'
  | 'angle-right'
  | 'archive'
  | 'arrow-bottom-right'
  | 'arrow-down-long'
  | 'arrow-first'
  | 'arrow-last'
  | 'arrow-left-long'
  | 'arrow-left-right'
  | 'arrow-right-long'
  | 'arrow-right'
  | 'arrow-top-right-square'
  | 'arrow-top-right'
  | 'arrow-up-top'
  | 'automations'
  | 'autopilot'
  | 'ban-dollar'
  | 'ban'
  | 'bath'
  | 'battery'
  | 'bed-times'
  | 'bed'
  | 'bed2'
  | 'bell'
  | 'bill-check'
  | 'bill-dollar'
  | 'bill-dollar2'
  | 'bill-percent'
  | 'bill-plus'
  | 'bill-times'
  | 'bill'
  | 'billing'
  | 'board-check'
  | 'bolt'
  | 'book-open'
  | 'book'
  | 'booking-canceled'
  | 'booking-channel'
  | 'booking-confirmed'
  | 'booking-created'
  | 'booking-engine'
  | 'bookmark'
  | 'bookmark2'
  | 'browser-times-check'
  | 'build'
  | 'building-dollar'
  | 'building-file-cycle'
  | 'building-incident'
  | 'building'
  | 'building2'
  | 'buildings'
  | 'calculator'
  | 'calendar-alert'
  | 'calendar-alt'
  | 'calendar-alt2'
  | 'calendar-alt3'
  | 'calendar-arrow-down'
  | 'calendar-arrow-right'
  | 'calendar-arrow-up'
  | 'calendar-ban'
  | 'calendar-check-sync'
  | 'calendar-check'
  | 'calendar-check2'
  | 'calendar-clock'
  | 'calendar-clock2'
  | 'calendar-cog'
  | 'calendar-day'
  | 'calendar-dollar-circle'
  | 'calendar-dollar'
  | 'calendar-link'
  | 'calendar-minus'
  | 'calendar-pause'
  | 'calendar-pause2'
  | 'calendar-pause3'
  | 'calendar-pencil'
  | 'calendar-plus'
  | 'calendar-plus2'
  | 'calendar-plus3'
  | 'calendar-plus4'
  | 'calendar-schedule'
  | 'calendar-share'
  | 'calendar-share2'
  | 'calendar-sync'
  | 'calendar-sync2'
  | 'calendar-time'
  | 'calendar-times'
  | 'calendar'
  | 'calendars'
  | 'calender-pause'
  | 'call'
  | 'card-accepted'
  | 'card-check'
  | 'card-declined'
  | 'card-deleted'
  | 'card-plus-circle'
  | 'card-rejected'
  | 'card-times'
  | 'card'
  | 'card2'
  | 'card3'
  | 'caret-left-right'
  | 'channel-disabled'
  | 'channels'
  | 'chart-bar-line'
  | 'chart-line'
  | 'chat-bolt'
  | 'chat-dollar'
  | 'chat-square'
  | 'chat-star'
  | 'chat-star2'
  | 'chat-sync'
  | 'chat'
  | 'chat2'
  | 'chats-star'
  | 'check-circle'
  | 'check-double'
  | 'check-square'
  | 'check-squre'
  | 'check'
  | 'check2'
  | 'checkbox'
  | 'checkin-door'
  | 'checkin'
  | 'checklist-dollar-circle'
  | 'checkout-door'
  | 'checkout'
  | 'child'
  | 'circle-linked'
  | 'circle-stack'
  | 'circle-stack2'
  | 'clock'
  | 'cloud-download'
  | 'cloud-upload'
  | 'cog-back'
  | 'cog-refresh'
  | 'cog'
  | 'coins'
  | 'collapse'
  | 'collapse2'
  | 'color-cards'
  | 'connect'
  | 'content'
  | 'contract-rejected'
  | 'contract-sent'
  | 'contract-signed'
  | 'contract-viewed'
  | 'copy-solid'
  | 'copy'
  | 'create-task'
  | 'cubes'
  | 'custom-theme'
  | 'dark-light'
  | 'dashboard-grid'
  | 'dashboard'
  | 'dashboard2'
  | 'day'
  | 'device-offline'
  | 'device-online'
  | 'discount-code'
  | 'discount-code2'
  | 'discount'
  | 'documents'
  | 'documents2'
  | 'dollar-back'
  | 'dollar-back2'
  | 'dollar-check'
  | 'dollar-circle-check'
  | 'dollar-circle-plus-circle'
  | 'dollar-circle-times'
  | 'dollar-circle'
  | 'dollar-circle2'
  | 'dollar-cycle'
  | 'dollar-light'
  | 'dollar-line-chart'
  | 'dollar-percent'
  | 'dollar-refresh-square'
  | 'dollar-refresh'
  | 'dollar-square'
  | 'dollar-sync'
  | 'dollar'
  | 'door-cog'
  | 'dots-circle-v'
  | 'double-arrow-right'
  | 'download'
  | 'download2'
  | 'download3'
  | 'drag-handler'
  | 'email-arrow-right'
  | 'envelope-alert'
  | 'envelope-check'
  | 'envelope-cog'
  | 'envelope-open'
  | 'envelope'
  | 'exclamation'
  | 'expand'
  | 'expand2'
  | 'expenses'
  | 'external-square'
  | 'external'
  | 'eye'
  | 'favorite'
  | 'feed-minus'
  | 'female'
  | 'field'
  | 'fields'
  | 'file-alt-check'
  | 'file-alt-dollar'
  | 'file-alt-plus'
  | 'file-alt'
  | 'file-alt2'
  | 'file-arrow-border'
  | 'file-arrow-down'
  | 'file-arrow-up'
  | 'file-chart-stars'
  | 'file-check'
  | 'file-dollar'
  | 'file-plus'
  | 'file-search'
  | 'file-signature'
  | 'file-signature2'
  | 'file-time'
  | 'filter'
  | 'folder'
  | 'format-clear'
  | 'gender'
  | 'globe'
  | 'globe2'
  | 'gps'
  | 'gps2'
  | 'grid-check'
  | 'grid'
  | 'guest-created'
  | 'guest-deleted'
  | 'guest-portal'
  | 'guest-updated'
  | 'guests'
  | 'gym'
  | 'hand'
  | 'home-percent'
  | 'house-hashtag'
  | 'house-lock'
  | 'http'
  | 'id-card-solid'
  | 'id-card'
  | 'inbox'
  | 'info-circle'
  | 'info'
  | 'initial'
  | 'initials'
  | 'inquiries'
  | 'integrations'
  | 'inventory'
  | 'invoice-canceled'
  | 'invoice-created'
  | 'invoice-paid'
  | 'invoices'
  | 'invoices2'
  | 'key'
  | 'key2'
  | 'kitchen'
  | 'language'
  | 'left-down'
  | 'light-stars'
  | 'light'
  | 'link-plus'
  | 'link'
  | 'link2'
  | 'links-cog'
  | 'list-check-square'
  | 'list-check'
  | 'list-square'
  | 'list'
  | 'logout'
  | 'logout2'
  | 'los-discount'
  | 'los-discount2'
  | 'mail-open'
  | 'mail-receive'
  | 'male'
  | 'map'
  | 'medal'
  | 'menu'
  | 'message-received'
  | 'minimize'
  | 'minus-circle'
  | 'money-back'
  | 'money-ban'
  | 'money-plus'
  | 'moneys'
  | 'moon'
  | 'multi-unit'
  | 'net-dollar'
  | 'net-plus'
  | 'note-check'
  | 'note-pad'
  | 'note'
  | 'paid-invoice'
  | 'paper-plane-h'
  | 'paper-plane2'
  | 'paper-sign'
  | 'paperclip'
  | 'parent-child'
  | 'parent-child2'
  | 'pc'
  | 'pdf'
  | 'pen-sign'
  | 'pen-sign2'
  | 'pencil-slash'
  | 'pencil'
  | 'percent'
  | 'person'
  | 'phone-book'
  | 'phone-card'
  | 'phone'
  | 'pin'
  | 'plane-arrive'
  | 'plane-depart'
  | 'plane'
  | 'play'
  | 'plug'
  | 'plug2'
  | 'plug3'
  | 'plus'
  | 'pm'
  | 'pointer'
  | 'pray'
  | 'printer'
  | 'printer2'
  | 'process'
  | 'property-number'
  | 'property'
  | 'question-circle'
  | 'rate'
  | 'rategenie'
  | 'rates'
  | 'recycle'
  | 'redo'
  | 'refresh'
  | 'refresh2'
  | 'relax'
  | 'rental'
  | 'rental2'
  | 'rentals'
  | 'replied-text'
  | 'reply-text'
  | 'reply'
  | 'report'
  | 'report2'
  | 'reports'
  | 'reset'
  | 'review-sent'
  | 'reviews'
  | 'right-down'
  | 'room'
  | 'save'
  | 'save2'
  | 'search'
  | 'selfie-solid'
  | 'selfie'
  | 'send-email'
  | 'send-notification'
  | 'send-sms'
  | 'send'
  | 'settings'
  | 'share-external'
  | 'share'
  | 'shield-check'
  | 'sign'
  | 'sign2'
  | 'smart-device2'
  | 'smart-devices'
  | 'smart-lock'
  | 'smart-lock2'
  | 'solid-dollar-plus'
  | 'sort'
  | 'source'
  | 'stacked-squares-flow'
  | 'star-half-solid'
  | 'star-outline'
  | 'star'
  | 'stealth'
  | 'store'
  | 'sun'
  | 'sync-dot'
  | 'tag-plus'
  | 'task-created'
  | 'task-square'
  | 'tasks'
  | 'template'
  | 'textbox'
  | 'theme'
  | 'thumb-stars'
  | 'thumbtack-solid'
  | 'thumbtack'
  | 'time-back'
  | 'time-back2'
  | 'time-based'
  | 'time-counter'
  | 'time-counter2'
  | 'time-running'
  | 'time'
  | 'times-circle'
  | 'times'
  | 'tools'
  | 'top-left-arrow-square'
  | 'trash-alt'
  | 'trash'
  | 'trash2'
  | 'trees'
  | 'undo'
  | 'unlink'
  | 'unlink2'
  | 'unlock'
  | 'unpaid-invoice'
  | 'upload'
  | 'user-card'
  | 'user-check'
  | 'user-cog'
  | 'user-door-open'
  | 'user-plus-circle'
  | 'user-plus'
  | 'user'
  | 'user2'
  | 'users'
  | 'users2'
  | 'users3'
  | 'video'
  | 'wallet-dollar'
  | 'wallet'
  | 'wallet2'
  | 'wallet3'
  | 'website'
  | 'whatsapp'
